import { render, staticRenderFns } from "./SaveCollectionBtnDialog.vue?vue&type=template&id=cdf63cfa&scoped=true"
import script from "./SaveCollectionBtnDialog.vue?vue&type=script&lang=js"
export * from "./SaveCollectionBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdf63cfa",
  null
  
)

export default component.exports